module.exports = __webpack_public_path__ + "static/media/san-fransisco.23aadf81.jpg";